// axiosConfig.js
import axios from "axios";
const instance = axios.create();
import jwtToken from "jwt-decode";

const saveErrorDetail = async (error) => {
  const jwtTokenData = error?.config?.headers?.jwtToken;
  try {
    const { compNumber, UserId, userName } = jwtToken(jwtTokenData || "");
    const apiUrl = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}/saveErrorDetail`;
    const errorPayload = {
      recordType: "API Errors",
      errorDetailPage: window.location.pathname.substring(1),
      errorDetailUrl:
        error?.config?.url ||
        error?.request?.responseURL ||
        error?.response?.request?.responseURL ||
        "",
      errorDetailPayload: error?.config?.data
        ? JSON.parse(error?.config?.data)
        : { data: "NA" },
      errorDetailResponse: error?.response?.data || {
        errorMessage: error?.message || "Not available",
      },
      userName: userName || "NA",
      companyNumber: compNumber || 9999,
    };
    const response = await axios.post(apiUrl, errorPayload, {
      headers: {
        "Content-Type": "application/json",
        authorization: process.env.REACT_APP_Auth_token,
      },
    });

    console.log("Saved error details successfully:", response?.data);
  } catch (saveErrorDetailError) {
    console.log("Error saving error details:", saveErrorDetailError);
  }
};

instance.interceptors.response.use(
  (response) => {
    if (response?.data?.status == "fail") {
      // console.log("API_Response statusCode : ", response?.request?.status);
      // console.log("API_Response status : ", response?.data?.status);
      // console.log("API_Response message : ", response?.data?.errorMessage);
      // console.log("API_Response URL : ", response?.request?.responseURL);
      saveErrorDetail({
        config: response.config,
        response: response,
      });
    }
    return response;
  },
  (error) => {
    if (error.response) {
      // console.log("API_Response Error statusCode:", error?.response.status);
      // console.log("API_Response Error status:", error?.response.data?.status);
      // console.log(
      //   "API_Response Error message:",
      //   error?.response.data?.errorMessage
      // );
      // console.log("API_Response CORS Error Message:", error?.message);
      // console.log("API_Response CORS Error URL:", error?.config?.url);
      // console.log("API_Response Error URL:", error?.request?.responseURL);
      // console.log("API_Response Error :", error);
      // console.log("API_Response :", error?.response);

      saveErrorDetail(error);
    } else if (error.request) {
      // console.log("API_Response No Response:", error?.request);
      // Save error details
      saveErrorDetail(error);
    } else if (error.code === "ECONNABORTED") {
      saveErrorDetail(error);
    } else {
      // console.log("API_Response Error Message:", error?.message);
      // console.log("API_Response Error:", error);

      // Handle CORS-related errors
      if (error.message.includes("CORS")) {
        console.log("API_Response CORS Error:", "Cross-Origin Request Blocked");
      }
      saveErrorDetail(error);
    }

    return Promise.reject(error);
  }
);

export default instance;
